import React, { Component, useEffect, useState } from "react";
import { Link } from "gatsby";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { useSelector } from "react-redux";
import { langs } from "../data/preferredLanguages";

const AccountProfile = ({ langData, editProfileUrl }) => {
  const guestInformation = useSelector(
    (store) => store.guestInformation.member.data
  );

  const objLang = langs.find(
    (lang) => lang.label === guestInformation?.guest?.language?.toLowerCase()
  );

  return (
    <>
      <div className="apr__row">
        <div className="apr__col col col--50">
          <dl>
            <dt>{langData?.label_title}</dt>
            <dd>{guestInformation?.guest?.salutation}</dd>
          </dl>

          <dl>
            <dt>{langData.label_gender}</dt>
            <dd>
              {guestInformation?.guest?.gender === "f"
                ? "Female"
                : guestInformation?.guest?.gender === "m"
                ? "Male"
                : ""}
            </dd>
          </dl>

          <dl>
            <dt>{langData?.label_email_address}</dt>
            <dd>{guestInformation?.guest?.email}</dd>
          </dl>

          <dl>
            <dt>{langData?.label_nationality}</dt>
            <dd>{guestInformation?.guest?.nationality}</dd>
          </dl>

          <dl>
            <dt>{langData?.label_birthday}</dt>
            <dd>{guestInformation?.guest?.birthdate}</dd>
          </dl>
        </div>
        <div className=" apr__col col col--50 member_info_right">
          <dl>
            <dt>{langData?.label_language}</dt>
            <dd>{!objLang ? "English" : objLang.slug}</dd>
          </dl>

          <dl>
            <dt>{langData.label_mobile_phone}</dt>
            <dd>{guestInformation?.guest?.phoneNumber}</dd>
          </dl>

          <dl>
            <dt>{langData?.label_address}</dt>
            <dd>{guestInformation?.guest?.address}</dd>
          </dl>

          <dl>
            <dt>{langData.label_city}</dt>
            <dd>{guestInformation?.guest?.countryOfResidence}</dd>
          </dl>

          <dl>
            <dt>{langData?.label_join_date}</dt>
            <dd>{guestInformation?.guest?.joinDate}</dd>
          </dl>
        </div>
      </div>
      <div className="text--center mart--xxl">
        <Link
          style={{ margin: "0 auto" }}
          to={editProfileUrl}
          className="button--tab--profile button--cta--tab--profile ">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.06 3.58988L20.41 4.93988C21.2 5.71988 21.2 6.98988 20.41 7.76988L7.18 20.9999H3V16.8199L13.4 6.40988L16.23 3.58988C17.01 2.80988 18.28 2.80988 19.06 3.58988ZM5 18.9999L6.41 19.0599L16.23 9.22988L14.82 7.81988L5 17.6399V18.9999Z"
              fill="#37B0E5"
            />
          </svg>
          <div>{langData?.label_edit_information}</div>
        </Link>
      </div>
    </>
  );
};

export default withAuthenticationRequired(AccountProfile);
